import { useSelector } from 'react-redux';
import { TaskIdV2 } from 'api/models';
import { LinkedResource } from 'api/tasks';
import { RootState } from 'data';

export const useTemplateActiveTaskLinkedResource = ([, taskId]: TaskIdV2):
  | LinkedResource[]
  | undefined => {
  return useSelector(
    (state: RootState) =>
      state.templates.project.data[state.templates.project.activeId].tasks[
        taskId
      ].linkedResources,
  );
};
